import * as signalR from '@microsoft/signalr';
import { HttpTransportType } from '@microsoft/signalr';
const configUrl = '/config.json';

export const getUrl = () => {
  return fetch(configUrl)
    .then((response) => response.json())
    .then((config) => config.singnalRUrl);
};

const urlPromise = getUrl();

export const connectionData = (async () => {
  const url = await urlPromise;
  return new signalR.HubConnectionBuilder()
    .withUrl(`${url}/dataChangeHub`, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
      withCredentials: true,
    })
    .build();
})();

export const connectionNotify = new signalR.HubConnectionBuilder().withUrl(`${getUrl()}/notificationsHub`).build();
